import { useEffect, useRef, useState } from 'react';
import { CaretRightOutlined, PauseOutlined } from '@ant-design/icons';
import { Button } from 'antd';

export default function AudioPlayPauseButton({
  src,
  size,
  className,
  doPlay,
  noGUI,
}) {
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef(new Audio(src));
  const play = () => {
    audioRef.current.play();
    setIsPlaying(true);
  };
  const pause = () => {
    audioRef.current.pause();
    setIsPlaying(false);
  };
  useEffect(() => {
    const stopAudio = () => setIsPlaying(false);
    if (audioRef.current) {
      audioRef.current.addEventListener('ended', stopAudio);
    }

    return () => {
      audioRef.current.pause();
      audioRef.current.removeEventListener('ended', stopAudio);
    };
  }, [audioRef.current]);

  useEffect(() => {
    if (audioRef.current && doPlay) {
      play();
    }
  }, [audioRef.current, doPlay]);

  return (
    <Button
      className={className}
      style={noGUI ? { display: 'none' } : {}}
      size={size}
      icon={isPlaying ? <PauseOutlined /> : <CaretRightOutlined />}
      onClick={isPlaying ? pause : play}
    />
  );
}
